import classNames from "classnames/bind";
import React, { useMemo } from "react";
import styles from "./DataList.module.scss";
import type { DataListProps } from "./types";

const cx = classNames.bind(styles);

/**
 * A component for displaying key/value pairs.
 */
const DataList = ({ data }: DataListProps) => {
  const displayRows = useMemo(() => data.sort(), [data]);

  return (
    <dl className={cx("container")}>
      {displayRows.map(({ label, value }) => (
        <>
          <dt className={cx("key")}>{label}</dt>
          <dd className={cx("value")}>{value ?? "-"}</dd>
        </>
      ))}
    </dl>
  );
};

export default DataList;
